/**
 * IXD↔IXD 대사 화면(`/ixd-preview-compare`)의 URL 계약.
 *
 * 대사 화면과 홈 패널이 같은 화면을 열므로 `comparison-url.ts` 와 같은 자리에 둔다
 * — 파라미터명이 바뀌면 고칠 곳은 여기 한 곳. 상대 경로를 돌려준다.
 */

/** 두 카드를 어떤 소스 종류로 열지. 값은 `IxdPreviewCompareSourceType`. */
export const PARAM_SOURCE_TYPE = "type";

const COMPARE_PATH = "/ixd-preview-compare";

/** 저장된(편집용) IXD 를 고르는 상태로 대사 화면을 연다 — "이전 IXD 불러오기". */
export const EXISTING_IXD_ENTRY_URL = `${COMPARE_PATH}?${PARAM_SOURCE_TYPE}=ixd_report`;
